import React, {useCallback, useMemo} from "react";
import {REDUCER} from "./interface";

interface Props {
    dispatch : React.Dispatch<any>
}
const useDispatch = (props: Props) => {
    const {dispatch} = props;

    const initState = useCallback((data: any) => {
        dispatch({type: REDUCER.SET_NEW_INITIAL_STATE, value: data})
    }, [dispatch])

    const updateThemeConfig = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_THEME_CONFIG, value: data})
    }, [dispatch])

    const updateNotifications = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_NOTIFICATIONS, value: data})
    }, [dispatch])

    const createNotifications = useCallback((data: any) => {
        dispatch({type: REDUCER.CREATE_NOTIFICATIONS, value: data})
    }, [dispatch])

    const updateToken = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_TOKEN, value: data})
    }, [dispatch])

    const updateUser = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_USER, value: data})
    }, [dispatch])

    const updateCompany = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_COMPANY, value: data})
    }, [dispatch])

    const updateWorkplace = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_WORKPLACE, value: data})
    }, [dispatch])

    const collapseSidebar = useCallback((data: any) => {
        dispatch({type: REDUCER.COLLAPSE_SIDEBAR, value: data})
    }, [dispatch])

    const addSocketEvent = useCallback((data: any) => {
        dispatch({type: REDUCER.ADD_SOCKET_EVENT, value: data})
    }, [dispatch])

    const removeSocketEvents = useCallback((data: any) => {
        dispatch({type: REDUCER.REMOVE_SOCKET_EVENTS, value: data})
    }, [dispatch])

    const updateCallStatus = useCallback((data: any) => {
        dispatch({type: REDUCER.UPDATE_CALL_STATUS, value: data})
    }, [dispatch])

    return useMemo(() => ({
        initState,
        updateThemeConfig,
        updateNotifications,
        createNotifications,
        updateToken,
        updateUser,
        updateCompany,
        updateWorkplace,
        collapseSidebar,
        removeSocketEvents,
        addSocketEvent,
        updateCallStatus
    }), [
        initState,
        updateThemeConfig,
        updateNotifications,
        createNotifications,
        updateToken,
        updateUser,
        updateCompany,
        updateWorkplace,
        collapseSidebar,
        removeSocketEvents,
        addSocketEvent,
        updateCallStatus
    ])
}

export default useDispatch;
